import {Text} from "grommet";
import React from "react";

const Label = ({ children, ...rest }) => (
    <Text weight={500} color="text-strong" size="small" margin={{ bottom: 'xsmall' }} {...rest}>
        {children}
    </Text>
);

export default Label;